import { useQuery } from '@hooks/reactQuery';

import { getRolesForKpiAlerts, getUsersForKpiAlerts } from '@api/kpiAlerts';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IRolesResponse, IUserListResponse } from '@interfaces/user/user';

import { TUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { KPI_ALERTS_RECIPIENTS, USER_GROUP } from '@constants/queryKeys';

export function useKpiAlertRecipients(): {
	usersOptions: TSelectOption<string>[];
	rolesOptions: TSelectOption<TUserRoles>[];
	isLoading: boolean;
} {
	const {
		data: users,
		isLoading: isLoadingUsers,
	} = useQuery<Array<IUserListResponse>, TSelectOption<string>[]>({
		queryKey: [KPI_ALERTS_RECIPIENTS],
		queryFn: getUsersForKpiAlerts,
		select: (users) => {
			return users?.map((item) => ({
				...item,
				value: item.id,
				label: item.fullName,
			}));
		},
		...refetchOptions,
	});

	const {
		data: roles,
		isLoading: isLoadingRoles,
	} = useQuery<Array<IRolesResponse>, TSelectOption<TUserRoles>[]>({
		queryKey: [USER_GROUP],
		queryFn: getRolesForKpiAlerts,
		select: (roles) => {
			return roles?.map((item) => ({
				...item,
				value: item.name,
				label: item.title,
			}));
		},
		...refetchOptions,
	});

	return {
		usersOptions: users || [],
		rolesOptions: roles || [],
		isLoading: isLoadingUsers || isLoadingRoles,
	};
}
